module.exports = __webpack_public_path__ + "static/media/header-naskah.1d4dd795.png";